export default __webpack_public_path__ + "static-front/media/QuestionnaireIcon.c04a2d37.svg";